


(function(a,b){var c=function(a,b,c){var d;return function e(){function g(){if(!c)a.apply(e,f);d=null}var e=this,f=arguments;if(d)clearTimeout(d);else if(c)a.apply(e,f);d=setTimeout(g,b||20)}};jQuery.fn[b]=function(a){return a?this.bind("resize",c(a)):this.trigger(b)}})(jQuery,"smartresize")

var $masonry = $('.masonry');
var navigationTopOffset;
var navigationHeight;

jQuery(window).load(function(){
  
  $masonry.show();
  
  
  
  $('.flexslider').flexslider({
    directionNav: true,
    controlNav: true,
    keyboardNav: true,
    slideshowSpeed: 5000,
    animation: "fade",
    prevText: 'Previous',
    nextText: 'Next',
    controlsContainer: '.custom-flexslider-controls'
  });
  $('.flexslider li img').click(function(){
    var url = jQuery(this).attr('data-url');
    if (url.length > 0) {window.location.href = url;}
  });
  
  
  
});

jQuery(document).ready(function($){
  
  $("a.zoom").fancybox({
    padding:0,
    'titleShow': false,
    overlayColor: '#ffffff',
    overlayOpacity: 0.5
  });
  
  
  $masonry.imagesLoaded(function(){
    $masonry.masonry({
      itemSelector : '.masonry-item'
    });
  });
  $(window).smartresize(function(){
    $masonry.masonry('reload');
  });
  

  $("nav.mobile select").change(function(){ window.location = jQuery(this).val(); });
  $('#product .thumbs a').click(function(){
    
    $('#placeholder').attr('href', $(this).attr('href'));
    $('#placeholder img').attr('src', $(this).attr('data-original-image'))
    
    $('#zoom-image').attr('href', $(this).attr('href'));
    return false;
  });
  
  
  $(".flexslider li img").each(function(){
    var url = $(this).attr('data-url');
    if(url != undefined){
      if (url.length > 0) { $(this).css("cursor","pointer");}
    }
  });
  
  
  
  
  $('input[type="submit"], input.btn, button').click(function(){ // remove ugly outline on input button click
    $(this).blur();
  })
  
  $("li.dropdown").hover(function(){
    $(this).children('.dropdown').show();
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 1.0
    }, 200);
  }, function(){
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 0.0
    }, 400, function(){
      $(this).hide();
    });
  });
  
  
}); // end document ready



(function( window ){

    var body = document.body,
        mask = document.createElement("div"),
        toggleSlideLeft = document.querySelector( ".toggle-slide-left" ),
        toggleSlideRight = document.querySelector( ".toggle-slide-right" ),
        toggleSlideTop = document.querySelector( ".toggle-slide-top" ),
        toggleSlideBottom = document.querySelector( ".toggle-slide-bottom" ),
        togglePushLeft = document.querySelector( ".toggle-push-left" ),
        togglePushRight = document.querySelector( ".toggle-push-right" ),
        togglePushTop = document.querySelector( ".toggle-push-top" ),
        togglePushBottom = document.querySelector( ".toggle-push-bottom" ),
        slideMenuLeft = document.querySelector( ".slide-menu-left" ),
        slideMenuRight = document.querySelector( ".slide-menu-right" ),
        slideMenuTop = document.querySelector( ".slide-menu-top" ),
        slideMenuBottom = document.querySelector( ".slide-menu-bottom" ),
        pushMenuLeft = document.querySelector( ".push-menu-left" ),
        pushMenuRight = document.querySelector( ".push-menu-right" ),
        pushMenuTop = document.querySelector( ".push-menu-top" ),
        pushMenuBottom = document.querySelector( ".push-menu-bottom" ),
        activeNav
    ;
    mask.className = "mask";

    /* slide menu left */
    toggleSlideLeft.addEventListener( "click", function(){
        classie.add( body, "sml-open" );
        document.body.appendChild(mask);
        activeNav = "sml-open";
    } );

    /* slide menu right */
    toggleSlideRight.addEventListener( "click", function(){
        classie.add( body, "smr-open" );
        document.body.appendChild(mask);
        activeNav = "smr-open";
    } );

    /* slide menu top */
    toggleSlideTop.addEventListener( "click", function(){
        classie.add( body, "smt-open" );
        document.body.appendChild(mask);
        activeNav = "smt-open";
    } );

    /* slide menu bottom */
    toggleSlideBottom.addEventListener( "click", function(){
        classie.add( body, "smb-open" );
        document.body.appendChild(mask);
        activeNav = "smb-open";
    } );

    /* push menu left */
    togglePushLeft.addEventListener( "click", function(){
        classie.add( body, "pml-open" );
        document.body.appendChild(mask);
        activeNav = "pml-open";
    } );

    /* push menu right */
    togglePushRight.addEventListener( "click", function(){
        classie.add( body, "pmr-open" );
        document.body.appendChild(mask);
        activeNav = "pmr-open";
    } );

    /* push menu top */
    togglePushTop.addEventListener( "click", function(){
        classie.add( body, "pmt-open" );
        document.body.appendChild(mask);
        activeNav = "pmt-open";
    } );

    /* push menu bottom */
    togglePushBottom.addEventListener( "click", function(){
        classie.add( body, "pmb-open" );
        document.body.appendChild(mask);
        activeNav = "pmb-open";
    } );

    /* hide active menu if mask is clicked */
    mask.addEventListener( "click", function(){
        classie.remove( body, activeNav );
        activeNav = "";
        document.body.removeChild(mask);
    } );

    /* hide active menu if close menu button is clicked */
    [].slice.call(document.querySelectorAll(".close-menu")).forEach(function(el,i){
        el.addEventListener( "click", function(){
            classie.remove( body, activeNav );
            activeNav = "";
            document.body.removeChild(mask);
        } );
    });

})( window );


